<template>
  <AdsButton
    v-bind="$attrs"
    :loading="$store.state.isLoading"
    class="ml-3"
    icon="mdi-content-save-outline"
    button-text="Save and Publish"
    v-on="$listeners"
  />
</template>

<script>
import {AdsButton} from '@nswdoe/doe-ui-core';

export default {
  name: 'SaveAndPublishButton',
  components: {AdsButton}
}
</script>

<style lang="scss" scoped>

</style>
